import { graphql } from 'react-relay';

export const getBetaNavigationVideoUrl = graphql`
  query BetaNavigationVideoUrlQuery($audience: BetaNavigationAudience!) {
    betaNavigationVideoUrl(audience: $audience)
  }
`;
